// extracted by mini-css-extract-plugin
export default {"description":"description__VqPy5","sm":"sm__fiZVC"};